import { SelectFilters } from './components'

interface IProps {
  animateSearchBar: boolean
  setShowFirtsSearch: (show: boolean) => void
  hasCleanFilters: boolean
  setHasCleanFilters: (hasCleanFilters: boolean) => void
}
export const Filters = ({
  animateSearchBar,
  hasCleanFilters,
  setShowFirtsSearch,
  setHasCleanFilters
}: IProps) => {
  return (
    <div className="bg-white h-full w-full gap-2 flex items-center px-6 border-b border-[#EBEDF0] z-1">
      <SelectFilters
        animateSearchBar={animateSearchBar}
        setShowFirtsSearch={setShowFirtsSearch}
        hasCleanFilters={hasCleanFilters}
        setHasCleanFilters={setHasCleanFilters}
      />
    </div>
  )
}
